module.exports = {
  DESKTOP: 'desktop',
  LAPTOP: 'laptop',
  IPAD: 'ipad',
  MOBILE: 'mobile',
  TABLET: 'table',
  TABLETPRO: 'tabletpro'
};
